import { render, staticRenderFns } from "./message.vue?vue&type=template&id=5a4885e8&scoped=true&"
import script from "./message.vue?vue&type=script&lang=js&"
export * from "./message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4885e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a4885e8')) {
      api.createRecord('5a4885e8', component.options)
    } else {
      api.reload('5a4885e8', component.options)
    }
    module.hot.accept("./message.vue?vue&type=template&id=5a4885e8&scoped=true&", function () {
      api.rerender('5a4885e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/shared/user/header_block/notification/message.vue"
export default component.exports